
import React, {Component} from 'react';
import {connect} from 'react-redux'
import { Button, Form, FormGroup, Popover, OverlayTrigger } from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { Box } from 'reactjs-admin-lte';
import Select from 'react-select';
import FontAwesome from 'react-fontawesome';
// import { Checkbox } from 'react-icheck';
import Moment from 'moment';
import IframeModal from 'component/element/IframeModal'
import ReportStore from 'stores/ReportStore';
import StockStore from 'stores/StockStore'
import AutopartStore from 'stores/AutopartStore'
// import Chart from 'chart.js';
// import { findDOMNode } from 'react-dom'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import PrintButtons from 'component/element/PrintButtons'
import PurchaseOrderDocModal from 'view/po/PurchaseOrderDocModal'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
import DatePicker from 'component/element/DatePicker'
import './Report.css'
const WHOLE_YEAR = momentHelper.getMonth()

// var MobileDetect = require('mobile-detect')
class ReportStockCardCost extends Component {

  constructor(props){
    super(props)

    const optionsRows = [10,20,50,100];
    this.state = ({
      check_date:[],
      dataFormat:[],
      all_page:[],
      data:[],
      loading: false,  
      length: 10,
      totalPage: 0,
      activePage: 1,
      report_title: this.props.messages['Fetching']+'..',
      defaultRows: 20,
      optionsRows: optionsRows,
      dataExcel:[],
      cat_id:'all',
      categorys:[],
      itemnum:'',
      query:'',
      options:[],
      showPO:false,
      poNo:'',
      showSO:false,
      soNo:'',
      isRange:false,
      day:'00',
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      isRange:false
    })
    this.barChart = null
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&this.props.show!==newProps.show) {
      this.loadData(this.state.year-543, this.state.month, this.state.day, 1, '', this.state.defaultRows, this.state.cat_id, this.state.itemnum)
      this.loadCategory()
    }
  }

  loadCategory() {
    StockStore.loadCategory('genpart',(result) =>{
      let categorys = [{label:'----- ทั้งหมด -----',value:'all'}]
      result.data.forEach((item,index)=>{
        categorys.push({label:item.name,value:item.cat_id})
      })
      this.setState({categorys:categorys})
    })
  }

  setItem(result) {
        let {check_date} = this.state
        let {dataFormat} = this.state
        let that = this
        var id = []
        var itemnum = []
        var bill_type = []
        var ref_type = []
        var added_date = []
        var in_cost = []
        var in_quantity = []
        var in_total = []
        var out_cost = []
        var out_quantity = []
        var out_total = []
        var balance_cost = []
        var balance_quantity = []
        var balance_total = []
        var sum_in_cost = 0
        var sum_in_quantity = 0
        var sum_in_total = 0
        var sum_out_cost = 0
        var sum_out_quantity = 0
        var sum_out_total = 0
        var sum_balance_cost = 0
        var sum_balance_quantity = 0
        var sum_balance_total = 0

        that.setState({data:[], dataFormat:[], check_date:[]})

        for (var ii=0;ii<result.data.length;ii++) {
          if (check_date.indexOf(result.data[ii].description)===-1) {
            check_date.push(result.data[ii].description)
          }
        }

        for (var i=0;i<check_date.length;i++) {
          // let left_in_cost = 0
          // let left_in_quantity = 0
          // let left_in_total = 0
  
          // let left_out_cost = 0
          // let left_out_quantity = 0
          // let left_out_total = 0
  
          for (var j=0;j<result.data.length;j++) {            
            if (check_date[i]===result.data[j].description) {
              if(result.data[j].record_type=='left_balance'){
                // left_in_cost = result.data[j].in_cost;
                // left_in_quantity = result.data[j].in_quantity;
                // left_in_total = result.data[j].in_total;
  
                // left_out_cost = result.data[j].out_cost;
                // left_out_quantity = result.data[j].out_quantity;
                // left_out_total = result.data[j].out_total;
              }
              id.push(result.data[j].ref_bill_no)
              itemnum.push(result.data[j].itemnum)
              added_date.push(result.data[j].added_date)
              bill_type.push(result.data[j].bill_type)
              ref_type.push(result.data[j].ref_type)
  
              in_cost.push(result.data[j].in_cost===undefined?0:result.data[j].in_cost)
              out_cost.push(result.data[j].out_cost===undefined?0:result.data[j].out_cost)
              balance_cost.push(result.data[j].balance_cost)
  
              in_quantity.push(result.data[j].in_quantity===undefined?0:result.data[j].in_quantity)
              out_quantity.push(result.data[j].out_quantity===undefined?0:result.data[j].out_quantity)
              balance_quantity.push(result.data[j].balance_quantity)
  
              in_total.push(result.data[j].in_total===undefined?0:result.data[j].in_total)
              out_total.push(result.data[j].out_total===undefined?0:result.data[j].out_total)
              balance_total.push(result.data[j].balance_total)
  
              sum_in_cost = (sum_in_cost*1) + ((result.data[j].in_cost===undefined?0:result.data[j].in_cost)*1)
              sum_out_cost = (sum_out_cost*1) + ((result.data[j].out_cost===undefined?0:result.data[j].out_cost)*1)
              sum_balance_cost = (sum_balance_cost*1) + ((result.data[j].balance_cost===undefined?0:result.data[j].balance_cost)*1)
  
              sum_in_quantity = (sum_in_quantity*1) + ((result.data[j].in_quantity===undefined?0:result.data[j].in_quantity)*1)
              sum_out_quantity = (sum_out_quantity*1) + ((result.data[j].out_quantity===undefined?0:result.data[j].out_quantity)*1)
              sum_balance_quantity = (sum_balance_quantity*1) + ((result.data[j].balance_quantity===undefined?0:result.data[j].balance_quantity)*1)
  
              sum_in_total = (sum_in_total*1) + ((result.data[j].in_total===undefined?0:result.data[j].in_total)*1)
              sum_out_total = (sum_out_total*1) + ((result.data[j].out_total===undefined?0:result.data[j].out_total)*1)
              sum_balance_total = (sum_balance_total*1) + ((result.data[j].balance_total===undefined?0:result.data[j].balance_total)*1)
            }
          }
          
          dataFormat.push({
            description: check_date[i],
            sum_in_cost: 0,
            sum_out_cost: 0,
            sum_balance_cost:  0,
            sum_in_quantity: 0,
            sum_out_quantity: 0,
            sum_balance_quantity:  0,
            sum_in_total: 0,
            sum_out_total: 0,
            sum_balance_total: 0
          })
          dataFormat.push({
            // description: check_date[i],
            meta: {
              id: id,
              itemnum: itemnum,
              bill_type: bill_type,
              ref_type: ref_type,
              added_date: added_date,
              in_cost: in_cost,
              out_cost: out_cost,
              balance_cost: balance_cost,
              in_quantity: in_quantity,
              out_quantity: out_quantity,
              balance_quantity: balance_quantity,
              in_total: in_total,
              out_total: out_total,
              balance_total: balance_total
            },
            sum_in_cost: sum_in_cost,
            sum_out_cost: sum_out_cost,
            sum_balance_cost:  sum_balance_cost,
            sum_in_quantity: sum_in_quantity,
            sum_out_quantity: sum_out_quantity,
            sum_balance_quantity:  sum_balance_quantity,
            sum_in_total: sum_in_total,
            sum_out_total: sum_out_total,
            sum_balance_total:  sum_balance_total
          })
          id = []
          itemnum = []
          bill_type = []
          ref_type = []
          added_date = []
          in_cost = []
          out_cost = []
          balance_cost = []
          sum_in_cost = 0
          sum_out_cost = 0
          sum_balance_cost = 0
  
          in_quantity = []
          out_quantity = []
          balance_quantity = []
          sum_in_quantity = 0
          sum_out_quantity = 0
          sum_balance_quantity = 0
  
          in_total = []
          out_total = []
          balance_total = []
          sum_in_total = 0
          sum_out_total = 0
          sum_balance_total = 0
        }

        that.setState({dataExcel:result.data, data:dataFormat, dataFormat:[], loading:false, report_title:that.props.messages['Data Not Found']})
  }

  loadData(year='', month='', day='', page = 1, lengthData='', rowsData=20, cat_id='all', q_itemnum='') { 
    let _length = rowsData
    if (lengthData==='all'||this.props.lengthData==='all') {
      _length = ''
    }

    if (year==='') {
      year = this.state.year - 543
    }
    if (month===''&&month!=='0') {
      month = this.state.month
    }
    if (day==='') {
      day = this.state.day
    }

    let that = this
    let start = (page * rowsData) - rowsData
    if (page === 1) {
      start = 0
      that.setState({ activePage: page })
    }
    
    that.setState({loading:true,isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year,defaultRows:rowsData})
    ReportStore.loadReportStockCardCost(year, month, day, start, _length, cat_id, q_itemnum, function(result) {
        const totalPage = result.data_count / rowsData
        that.setItem(result)
        that.setState({totalPage: Math.ceil(totalPage)})
    })  
  }

  loadDataRange(start='',end='',cat_id='all',q_itemnum='') {
    let that = this
    ReportStore.loadReportStockCardCostRange(start, end, '', '', cat_id, q_itemnum, function(result) {
      that.setItem(result)
    })
  }

  getStyleTb() {
    if (this.props.showPrintPreview === true) {
      return "table table-responsive table-report-profit table-print-profit"
    } else {
      return "table table-responsive table-bordered-solid table-report-profit"
    }
  }

  handleSelect(e) {
    this.setState({ activePage: e, isRange:false })
    let year = this.state.year
    if (year>0)
      year = year-543
    this.loadData(year, this.state.month, this.state.day, e, '', this.state.defaultRows, this.state.cat_id, this.state.itemnum)
  }

  onYearChange(e) {
    let length = ''
    if (e.value===0) {
      this.loadData(0, 0, 0, 1, length, this.state.defaultRows, this.state.cat_id, this.state.itemnum)
    } else {
      var year = e.value - 543
      var date = year+"-"+this.state.month
      let curDay = 0
      curDay = this.getAllDayOfMonth(date)
      this.loadData(year, this.state.month, curDay, 1, length, this.state.defaultRows, this.state.cat_id, this.state.itemnum)
    }  
    this.setState({ activePage:1,year:e.value,isRange:false })
    // let callBackYear = {value:e.value,key:'year',activeDay:0}
    // this.props.onDateChange(callBackYear)
    
    // setTimeout(()=>{
    //   let callBackMonth = {value:0,key:'month',activeDay:0}
    //   this.props.onDateChange(callBackMonth)
    // },100)

    // setTimeout(()=>{
    //   let callBackDay = {value:0,key:'day',activeDay:0}
    //   this.props.onDateChange(callBackDay)
    // },200)
  }

  onMonthChange(e) {
    let length = ''
    let year = this.state.year
    if (year>0) {
      year = year-543
      var date = year+"-"+e.value
      let curDay = 0
      curDay = this.getAllDayOfMonth(date)
      this.loadData(year, e.value, curDay, 1, length, this.state.defaultRows, this.state.cat_id, this.state.itemnum)
      // let callBack = {value:e.value,key:'month',activeDay:curDay}
      // this.props.onDateChange(callBack)
    } else {
      this.loadData(0, e.value, 0, 1, length, this.state.defaultRows, this.state.cat_id, this.state.itemnum)
      // let callBack = {value:e.value,key:'month',activeDay:0}
      // this.props.onDateChange(callBack)
    }
    this.setState({ activePage:1, month:e.value,isRange:false })
  }

  onDayChange(e) {
    let length = ''
    let year = this.state.year
    if (year>0)
      year = year-543
    this.loadData(year, this.state.month, e.value, 1, length, this.state.defaultRows, this.state.cat_id, this.state.itemnum)
    this.setState({day:e.value,isRange:false})
    // let callBack = {value:e.value,key:'day',activeDay:e.value}
    // this.props.onDateChange(callBack)
  }

  onCategoryChange(e) {
    let length = ''
    let year = this.state.year
    if (year>0)
      year = year-543
    this.loadData(year, this.state.month, this.state.day, 1, length, this.state.defaultRows, e.value, this.state.itemnum)
    this.setState({cat_id:e.value,isRange:false})
  }

  onRowsPerPageChange(e) {
    let year = this.state.year
    let rows = e
    if (year>0) {
      year = year-543
      var date = year+"-"+this.state.month
      let curDay = 0
      curDay = this.getAllDayOfMonth(date)
      this.loadData(year, this.state.month, curDay, 1, '', rows, this.state.cat_id, this.state.itemnum)
      // let callBack = {key:false,activeDay:curDay}
      // this.props.onDateChange(callBack)
    } else {
      this.loadData(0, this.state.month, this.state.day, 1, '', e.value, this.state.cat_id, this.state.itemnum)
      // let callBack = {key:false,activeDay:0}
      // this.props.onDateChange(callBack)
    }
    this.setState({ defaultRows: rows, activePage:1,isRange:false })
  }

  onPrintClick(){
    var year = this.state.year
    var month = this.state.month
    var day = this.state.day
    if (year>0) {
      year = year-543
    } else {
      month = 0
      day = 0
    }
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportStockCardCost&year='+year+'&month='+month+'&day='+day+'&isRange=false'+'&cat_id='+this.state.cat_id+'&itemnum='+this.state.itemnum
    if (isRange) {
        let {dayRange,monthRange,yearRange} = this.state
        let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
        let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+(yearRange-543)
        param = 'PrintReportStockCardCost&start_date='+start+'&end_date='+end+'&isRange=true'+'&cat_id='+this.state.cat_id+'&itemnum='+this.state.itemnum
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day,1,'',this.state.defaultRows,this.state.cat_id,this.state.itemnum)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,this.state.cat_id,this.state.itemnum)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end,this.state.cat_id,this.state.itemnum)
  }

  renderWCalendar() {
    return(
      <div style={{display:'inline-flex'}}>
        <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?momentHelper.getDay():this.state.day)+'/'+(this.state.month=='00'?WHOLE_YEAR:this.state.month)+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.dayRange=='00'?momentHelper.getDay():this.state.dayRange)+'/'+(this.state.monthRange=='00'?WHOLE_YEAR:this.state.monthRange)+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
          />
      </div>
    )
  }

  renderTable() {
    let {messages} = this.props
    return(
      <div className='table-responsive'>
        <table className='table table-bordered-solid table-report-profit table-report-stock-card-cost' style={{minWidth:'1800px'}}>
          <thead>
            <tr>
              <th rowSpan={2} style={{width:"50px"}} className="text-center">ลำดับ</th>
              <th rowSpan={2} style={{width:"200px"}} className="text-center">วันที่</th>
              <th rowSpan={2} style={{width:"200px",minWidth:'200px'}} className="text-center">{messages['Bill No']}</th>
              <th rowSpan={2} style={{width:"120px"}} className="text-center">{messages['Bill Type']}</th>
              <th className="text-center" colSpan={3}>นำเข้า</th>
              <th className="text-center" colSpan={3}>ส่งออก</th>
              <th className="text-center" colSpan={3}>คงเหลือ</th>
            </tr>
            <tr>
              <th style={{width:'120px'}} className="text-center">จำนวน</th>
              <th style={{width:'120px'}} className="text-center">ต้นทุน</th>
              <th style={{width:'120px'}} className="text-center">รวมราคา</th>
              <th style={{width:'120px'}} className="text-center">จำนวน</th>
              <th style={{width:'120px'}} className="text-center">ต้นทุน</th>
              <th style={{width:'120px'}} className="text-center">รวมราคา</th>
              <th style={{width:'120px'}} className="text-center">จำนวน</th>
              <th style={{width:'120px'}} className="text-center">ต้นทุน (เฉลี่ย)</th>
              <th style={{width:'120px'}} className="text-center">รวมราคา</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
            {/* {this.renderRowSummary()} */}
          </tbody>
        </table>
      </div>  
    )
  }

  renderRowSummary() {
    let {data} = this.state
    let sum_in_quantity = 0
    let sum_out_quantity = 0
    // let sum_balance_quantity = 0
    let sum_in_cost = 0
    let sum_out_cost = 0
    // let sum_balance_cost = 0
    let sum_in_total = 0
    let sum_out_total = 0
    // let sum_balance_total = 0
    data.forEach(function(item,index) {
      sum_in_quantity += parseFloat(item.sum_in_quantity)
      sum_out_quantity += parseFloat(item.sum_out_quantity)
      // sum_balance_quantity += parseFloat(item.sum_balance_quantity)
      sum_in_cost += parseFloat(item.sum_in_cost)
      sum_out_cost += parseFloat(item.sum_out_cost)
      // sum_balance_cost += parseFloat(item.sum_balance_cost)
      sum_in_total += parseFloat(item.sum_in_total)
      sum_out_total += parseFloat(item.sum_out_total)
      // sum_balance_total += parseFloat(item.sum_balance_total)
    })

    return(
      <tr>
        <td colSpan={4} className='text-right'><div className='br'><b>ยอดรวมสุทธิ</b></div></td>
        <td className='bd-sum text-center'><div className='br'><b>{this.getNumberFormat(sum_in_quantity)}</b></div></td>
        <td className='bd-sum text-right'><div className='br'><b>-</b>{' '}</div></td>
        <td className='bd-sum text-right'><div className='br'><b>{this.getNumberFormat(sum_in_total)}</b></div></td>
        <td className='bd-sum text-center'><div className='br'><b>{this.getNumberFormat(sum_out_quantity)}</b></div></td>
        <td className='bd-sum text-right'><div className='br'><b>-</b>{' '}</div></td>
        <td className='bd-sum text-right'><div className='br'><b>{this.getNumberFormat(sum_out_total)}</b></div></td>
        <td className='bd-sum text-center'><div className='br'><b>-</b></div></td>
        <td className='bd-sum text-right'><div className='br'><b>-</b></div></td>
        <td className='bd-sum text-right'><div className='br'><b>-</b></div></td>
      </tr>
    )
  }

  // onIconClick(workNo,e) {
  //   if(this.props.onWorkClick!==undefined){
  //     this.props.onWorkClick(workNo)
  //   }
  // }

  onIconClick(item,index){
    if (item.meta.ref_type[index]==='purchaseorder') {
      this.setState({showPO:true,poNo:item.meta.id[index]})
      this.refs.poModal.loadData(item.meta.id[index])
    } else {
      if (this.props.onWorkClick!==undefined){
        this.props.onWorkClick(item.meta.id[index])
      }
    }  
  }

  onPOHide(){
    this.setState({showPO:false,poNo:''})
  }

  onSOHide(){
    this.setState({showSO:false,soNo:''})
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    if (_val===0||_val==='0')
      return <br />
    else  
      return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renderColTitle(item) {
    return(
      <td colSpan={13}>
        <div className='bg-title br'><b>{item}</b></div>
      </td>
    )
  }

  renderRowData() {
    let {data} = this.state
    let {messages} = this.props
    var sum_all_day_in_cost = 0
    var sum_all_day_in_quantity = 0
    var sum_all_day_in_total = 0

    var sum_all_day_out_cost = 0
    var sum_all_day_out_quantity = 0
    var sum_all_day_out_total = 0

    var sum_all_day_balance_cost = 0
    var sum_all_day_balance_quantity = 0
    var sum_all_day_balance_total = 0
    if (this.state.data.length>0) {
      return(
        data.map((item, i) => {
          sum_all_day_in_cost = (sum_all_day_in_cost*1) + (item.sum_in_cost*1)
          sum_all_day_in_quantity = (sum_all_day_in_quantity*1) + (item.sum_in_quantity*1)
          sum_all_day_in_total = (sum_all_day_in_total*1) + (item.sum_in_total*1)

          sum_all_day_out_cost = (sum_all_day_out_cost*1) + (item.sum_out_cost*1)
          sum_all_day_out_quantity = (sum_all_day_out_quantity*1) + (item.sum_out_quantity*1)
          sum_all_day_out_total = (sum_all_day_out_total*1) + (item.sum_out_total*1)

          sum_all_day_balance_cost = (sum_all_day_balance_cost*1) + (item.sum_balance_cost*1)
          sum_all_day_balance_quantity = (sum_all_day_balance_quantity*1) + (item.sum_balance_quantity*1)
          sum_all_day_balance_total = (sum_all_day_balance_total*1) + (item.sum_balance_total*1)

          // var check_last = "none" 
          // if (i===this.state.data.length-1) {
          //   check_last = ""
          // }

          if (typeof item.description!=='undefined') {
            return(
              <tr key={i}>
                {this.renderColTitle(item.description)}
              </tr>  
            )  
          }  
          return(
            <tr key={i}>
              <td className='text-center'>
                {
                  item.meta.added_date.map((added_date, index) => {
                    return(
                      <div key={index} className="bd-date br">
                        <div>{index>0?index:<br />}</div>
                      </div>
                    )
                  })  
                }
                {/* <div className="bd-sum"><br /></div> */}
                <div><br /></div>
              </td>
              <td className='text-center'>
                {
                  item.meta.added_date.map((added_date, index) => {
                    return(
                      <div key={index} className="bd-date br">
                        <div>{added_date===''?<br />:added_date}</div>
                      </div>
                    )
                  })  
                }
                {/* <div className="bd-sum"><br /></div> */}
                <div><br /></div>
              </td>
              <td className='text-center'>
                {
                  item.meta.id.map((id, index) => {
                    let title = messages['Bill No']+" "+id
                    let popoverHoverFocus = (
                      <Popover id="popover-trigger-hover-focus" title={title}>
                        <strong>{messages['Click Icon To View Worksheet']}</strong>
                      </Popover>
                    )
                    return(
                      <div key={index} className="bd-date br">
                        {id===''?<div><br /></div>
                        :
                        <div>
                          {id} &nbsp;
                          <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}>
                            <FontAwesome style={{fontSize:'15px'}} onClick={this.onIconClick.bind(this,item,index)} className="text-blue" name='file-text-o'/>
                          </OverlayTrigger>
                        </div>}
                      </div>
                    )
                  })  
                }
                {/* <div className="bd-sum"><br /></div> */}
                <div><br /></div>
              </td>
              <td className='text-center'>
                {
                  item.meta.bill_type.map((bill_type, index) => {
                    return(
                      <div key={index} className="bd-date br">
                        <div>{bill_type}</div>
                      </div>
                    )
                  })  
                }
                {/* <div className="bd-sum br text-right"><b>รวม</b></div> */}
                <div className="br text-right"><b>รวม</b></div>
              </td>
              <td className="text-center">
                {
                  item.meta.in_quantity.map((in_quantity, index) => {
                    let bd_sum = ""
                    if (index===item.meta.in_quantity.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(in_quantity)}</div>
                      </div>
                    )
                  })
                }
                {/* <div className="bd-sum br">{this.getNumberFormat(item.sum_in_quantity)}</div> */}
                <div className="br">{this.getNumberFormat(item.sum_in_quantity)}</div>
              </td>
              <td className="text-right">
                {
                  item.meta.in_cost.map((in_cost, index) => {
                    let bd_sum = ""
                    if (index===item.meta.in_cost.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(in_cost)}</div>
                      </div>
                    )
                  })
                }
                {/* <div className="bd-sum br">(เฉลี่ย)  {this.getNumberFormat(item.sum_in_total/item.sum_in_quantity)}</div> */}
                <div className="br">(เฉลี่ย)  {this.getNumberFormat(item.sum_in_total/item.sum_in_quantity)}</div>
              </td>
              <td className="text-right">
                {
                  item.meta.in_total.map((in_total, index) => {
                    let bd_sum = ""
                    if (index===item.meta.in_total.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(in_total)}</div>
                      </div>
                    )
                  })
                }
                {/* <div className="bd-sum br">{this.getNumberFormat(item.sum_in_total)}</div> */}
                <div className="br">{this.getNumberFormat(item.sum_in_total)}</div>
              </td>
              <td className="text-center">
                {
                  item.meta.out_quantity.map((out_quantity, index) => {
                    let bd_sum = ""
                    if (index===item.meta.out_quantity.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(out_quantity)}</div>
                      </div>
                    )
                  })
                }
                {/* <div className="bd-sum br">{this.getNumberFormat(item.sum_out_quantity)}</div> */}
                <div className="br">{this.getNumberFormat(item.sum_out_quantity)}</div>
              </td>
              <td className="text-right">
                {
                  item.meta.out_cost.map((out_cost, index) => {
                    let bd_sum = ""
                    if (index===item.meta.out_cost.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(out_cost)}</div>
                      </div>
                    )
                  })
                }
                {/* <div className="bd-sum br">(เฉลี่ย)  {this.getNumberFormat(item.sum_out_total/item.sum_out_quantity)}</div> */}
                <div className="br">(เฉลี่ย)  {this.getNumberFormat(item.sum_out_total/item.sum_out_quantity)}</div>
              </td>
              <td className="text-right">
                {
                  item.meta.out_total.map((out_total, index) => {
                    let bd_sum = ""
                    if (index===item.meta.out_total.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(out_total)}</div>
                      </div>
                    )
                  })
                }
                {/* <div className="bd-sum br">{this.getNumberFormat(item.sum_out_total)}</div> */}
                <div className="br">{this.getNumberFormat(item.sum_out_total)}</div>
              </td>
              <td className="text-center">
                {
                  item.meta.balance_quantity.map((balance_quantity, index) => {
                    let bd_sum = ""
                    if (index===item.meta.balance_quantity.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(balance_quantity)}</div>
                      </div>
                    )
                  })
                }
                {/* <div className="bd-sum br">{'-'}</div> */}
                <div className="br">{'-'}</div>
              </td>
              <td className="text-right">
                {
                  item.meta.balance_cost.map((balance_cost, index) => {
                    let bd_sum = ""
                    if (index===item.meta.balance_cost.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(balance_cost)}</div>
                      </div>
                    )
                  })
                }
                {/* <div className="bd-sum br">{'-'}</div> */}
                <div className="br">{'-'}</div>
              </td>
              <td className="text-right">
                {
                  item.meta.balance_total.map((balance_total, index) => {
                    let bd_sum = ""
                    if (index===item.meta.balance_total.length-1) {
                      bd_sum = "bd-sum"
                    }

                    return(
                      <div key={index} className={'bd-date br '+bd_sum}>
                        <div>{this.getNumberFormat(balance_total)}</div>
                      </div>
                    )
                  })
                }
                {/* <div className="bd-sum br">{'-'}</div> */}
                <div className="br">{'-'}</div>
              </td>
            </tr>
          )
        })      
      )
    } else {
      return(<tr><td colSpan={13}><div className='br'>{messages['Data Not Found']}</div></td></tr>)
    }  
  }

  onMenuItemSelect(index){
    this.props.keyChange(index)
  }

  onExportExcel() {
    let {messages} = this.props
    let {year,month,day} = this.state
    const worksheet = XLSX.utils.table_to_book(document.getElementById('report-stock-card-cost'));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    let fileName = messages['Report Name']+'-'+year+'-'+month+'-'+day+'.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName)
  }

  onSearch(query){
    // let {data} = this.state
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartItemList(-1,query,function(result){
      // console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit,exportQuantity:item.quantity,costPerUnit:item.cost_per_unit,discountPercent:item.discount_percent,discountAmount:item.discount_amount,partFrom:''}
      })
      that.setState({options:options})
    })
   
    //this.setState({options:options})
  }

  onTypeaheadChange(option){
    let {query,itemnum} = this.state
    if(option.length===1){
      query = option[0].detail
      if(typeof option[0].itemnum !=='undefined'){
        itemnum = option[0].itemnum
        let year = this.state.year
        if (year>0)
          year = year-543
        this.loadData(year, this.state.month, this.state.day, 1, '', this.state.defaultRows, this.state.cat_id, itemnum)
      }
    }
    this.setState({query:query,itemnum:itemnum})
  }

  onTypeaheadInputChange(_query){
    //console.log('typeChagne',e,text)
    let {query} = this.state
    query = _query
    this.setState({query:query})
    if (query==='') {
      this.setState({itemnum:''})
      let year = this.state.year
      if (year>0)
        year = year-543
      this.loadData(year, this.state.month, this.state.day, 1, '', this.state.defaultRows, this.state.cat_id, '')
    }
  }

  renderRowDataExcel() {
    let {messages} = this.props
    let {dataExcel} = this.state
    if (dataExcel.length===0) {
      return(<tr><td colSpan={13}>{messages['Data Not Found']}</td></tr>)
    } else {
      return(
        dataExcel.map((item,index)=> {
          return(
            <tr key={index}>
              <td className='text-center'>{item.ref_bill_no}</td>
              <td className='text-center'>{item.added_date}</td>
              <td className='text-center'>{item.description}</td>
              <td className="text-center">{item.bill_type}</td>
              <td className="text-center">{item.in_quantity}</td>
              <td className="text-center">{item.in_cost}</td>
              <td className="text-center">{item.in_total}</td>
              <td className="text-center">{item.out_quantity}</td>
              <td className="text-center">{item.out_cost}</td>
              <td className="text-center">{item.out_total}</td>
              <td className="text-center">{item.balance_quantity}</td>
              <td className="text-center">{item.balance_cost}</td>
              <td className="text-center">{item.balance_total}</td>
            </tr>
          )
        })
      )
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00') {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00') {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00') {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTableExcel() {
    let {messages} = this.props
    return(
      <div className="display-overflow" style={{display:'none'}}>
        <table id='report-stock-card-cost' className="table table-responsive table-bordered-solid table-hover table-report-profit">
          <thead>
            <tr>
              <th colSpan={13}>{messages['Report Name']} {this.getDate()}</th>
            </tr>
            <tr>
              <th rowSpan={2} style={{width:"200px"}} className="text-center">{messages['Bill No']}</th>
              <th rowSpan={2} style={{width:"100px"}} className="text-center">{messages['Date']}</th>
              <th rowSpan={2} style={{width:"100px"}} className="text-center">{messages['Description']}</th>
              <th rowSpan={2} style={{width:"100px"}} className="text-center">{messages['Bill Type']}</th>
              <th className="text-center" colSpan={3}>นำเข้า</th>
              <th className="text-center" colSpan={3}>ส่งออก</th>
              <th className="text-center" colSpan={3}>คงเหลือ</th>
            </tr>
            <tr>
              <th style={{width:'90px'}} className="text-center">จำนวน</th>
              <th style={{width:'90px'}} className="text-center">ต้นทุน</th>
              <th style={{width:'90px'}} className="text-center">รวมราคา</th>
              <th style={{width:'90px'}} className="text-center">จำนวน</th>
              <th style={{width:'90px'}} className="text-center">ต้นทุน</th>
              <th style={{width:'90px'}} className="text-center">รวมราคา</th>
              <th style={{width:'90px'}} className="text-center">จำนวน</th>
              <th style={{width:'90px'}} className="text-center">ต้นทุน (เฉลี่ย)</th>
              <th style={{width:'90px'}} className="text-center">รวมราคา</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowDataExcel()}
            {/* {this.renderRowSummary()} */}
          </tbody>
        </table>
      </div>      
    )
  }

  _renderMenuItemChildren(option, props, index) {
    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} (หมวด{option.categoryName}) - {option.pricePerUnit} บาท</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail}</span>
        </div>
      );
    }
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day,1,'',this.state.defaultRows,this.state.cat_id,this.state.itemnum)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render(){
      let {messages} = this.props
      return (
        <div className='report-stock-card-cost'>  
          <Box loading={this.state.loading}>
            <Box.Header border={true}>
              {this.props.renderMenu()}
            </Box.Header>
            <Box.Body>
              <Form inline style={{marginBottom:'5px'}}>
                <FormGroup style={{verticalAlign:'top'}}>
                  <SelectDate
                    wholeYear={true}
                    year={this.state.year}
                    month={this.state.month}
                    day={this.state.day}
                    onMonthChange={this.onMonthChange.bind(this)}
                    onYearChange={this.onYearChange.bind(this)}
                    onDayChange={this.onDayChange.bind(this)}
                    dayWCalendar={true}
                    renderWCalendar={this.renderWCalendar.bind(this)}
                  />
                </FormGroup>
                {' '}
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={ this.state.cat_id }
                    style={{ width: "200px" }}
                    options={this.state.categorys}
                    onChange={this.onCategoryChange.bind(this)}
                  />
                </FormGroup>
                {' '}
                <FormGroup>
                  <AsyncTypeahead
                    allowNew={false}
                    multiple={false}
                    newSelectionPrefix={'เพิ่มรายการใหม่'+' : '}   
                    promptText={'พิมพ์รายการเพื่อค้นหา...'}           
                    searchText={'กำลังค้นหา...'}               
                    selected={[{detail:this.state.query}]}
                    options={this.state.options}
                    labelKey="detail"
                    onSearch={this.onSearch.bind(this)}
                    onChange={this.onTypeaheadChange.bind(this)}
                    onInputChange={this.onTypeaheadInputChange.bind(this)}
                    placeholder="ชื่อรายการ..."
                    renderMenuItemChildren={this._renderMenuItemChildren.bind(this)}
                  />    
                </FormGroup>
                {' '}
                <FormGroup>
                  <Button                 
                    className='bg-maroon'
                    onClick={this.onPrintClick.bind(this)}
                  >
                    <FontAwesome name='print'/>&nbsp;{messages['Print Document']}
                  </Button>
                </FormGroup>
                {' '}
                <FormGroup>
                  <PrintButtons
                    width={''}
                    display={''}
                    marginLeft={''}
                    onExportExcel={this.onExportExcel.bind(this)}
                  />
                </FormGroup>
              </Form>
              <div>
                {this.renderDateRange()}
                {this.renderTable()}
                {this.renderTableExcel()}
                {/* <div className="text-right">
                  <Form inline>
                    <FormGroup>
                      {messages['Number Of Rows Per Page']}
                    </FormGroup>  
                    {' '}
                    <FormGroup>
                      <DropdownButton id='' bsStyle={'default'} title={this.state.defaultRows} onSelect={this.onRowsPerPageChange.bind(this)}>
                        {this.state.optionsRows.map((item,index)=>(
                          <MenuItem key={index} eventKey={item}>{item}</MenuItem>  
                        ))}
                      </DropdownButton>
                    </FormGroup> 
                    {' '} 
                    <FormGroup style={{lineHeight:'10px'}}>
                      <Pagination
                        prev={messages['Previous']}
                        next={messages['Next']}
                        first={false}
                        last={false}
                        ellipsis
                        boundaryLinks
                        items={this.state.totalPage}
                        maxButtons={5}
                        activePage={this.state.activePage}
                        onSelect={this.handleSelect.bind(this)}
                      />
                    </FormGroup>
                  </Form>  
                </div> */}
              </div>
              <IframeModal ref='iframe' title={messages['Print Document']} />
            </Box.Body>
          </Box>
          <PurchaseOrderDocModal ref='poModal' show={this.state.showPO} poNo={this.state.poNo} onHide={this.onPOHide.bind(this)}/>          
        </div>
      )
    
  }
}


export default ReportStockCardCost = connect(
  (state) => ({messages: state.message.view.report.ReportStockCardCost}),null,null,{withRef:true}
)(ReportStockCardCost);




// WEBPACK FOOTER //
// ./src/view/report/stock/ReportStockCardCost.js